import React from 'react';
import { motion } from 'framer-motion';
import { ArrowIcon } from './icons/ArrowIcon';
export function Hero() {
  const scrollToPrice = () => {
    const element = document.getElementById('precio');
    if (element) {
      const headerOffset = 60;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };
  return <section id="inicio" className="relative w-full bg-[#FDFBF7] pt-16 md:pt-32 pb-12 md:pb-20 px-3 md:px-4 overflow-hidden" data-id="element-123">
      <div className="max-w-6xl mx-auto" data-id="element-124">
        <div className="grid lg:grid-cols-2 gap-6 md:gap-8 lg:gap-12 items-center" data-id="element-125">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="space-y-4 md:space-y-6 text-center lg:text-left" data-id="element-126">
            <span className="inline-block text-[#D4AF7A] font-medium tracking-[0.2em] text-xs md:text-sm uppercase" data-id="element-127">
              MASTER HYDRA GLOSS LIPS™ 2.0
            </span>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-semibold text-[#3D3028] leading-[1.15] md:leading-[1.2] tracking-tight" data-id="element-128">
              Convertite en Especialista en Hydra Lips + BB Lips en menos de 7
              días,{' '}
              <span className="text-[#E5A5A0]" data-id="element-129">
                incluso si hoy estás empezando desde cero
              </span>
            </h1>

            <div className="space-y-3 md:space-y-4" data-id="element-130">
              <h2 className="text-sm md:text-base lg:text-lg text-[#3D3028]/70 font-normal leading-snug" data-id="element-131">
                ¿Querés ofrecer un servicio premium, cobrar mejor y destacarte
                como profesional… pero todavía no te sentís segura con la
                técnica?
              </h2>

              <p className="text-xs md:text-sm lg:text-base text-[#3D3028]/60 leading-relaxed" data-id="element-132">
                Este Master fue creado para que dejes de improvisar y empieces a
                trabajar con confianza, método y resultados reales, incluso si
                nunca hiciste Hydra Lips o BB Lips.
              </p>
            </div>

            {/* Hero Image - Mobile Only (between subheadline and CTA) */}
            <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} className="lg:hidden pt-2" data-id="element-133">
              <button onClick={scrollToPrice} className="block relative rounded-xl md:rounded-2xl overflow-hidden shadow-lg md:shadow-xl border border-[#D4C4B0]/20 hover:shadow-2xl transition-shadow duration-300 cursor-pointer w-full" data-id="element-134">
                <img src="https://cdn.magicpatterns.com/uploads/v2FtTdrXnipb7phZdB754r/fa807582-4f21-4da1-bce9-cfdad40f259c.png" alt="Domina el Hydra Gloss Lips - Master Online Paso a Paso" className="w-full h-auto object-cover" data-id="element-135" />
              </button>
            </motion.div>

            {/* CTA Button - Branded Design */}
            <div className="pt-3 md:pt-6 w-full lg:w-auto" data-id="element-136">
              <motion.button onClick={scrollToPrice} whileHover={{
              scale: 1.02
            }} whileTap={{
              scale: 0.98
            }} className="relative w-full lg:inline-flex flex-col items-center justify-center gap-2 px-10 py-6 rounded-xl md:rounded-2xl overflow-hidden group" style={{
              background: 'linear-gradient(135deg, #E5A5A0 0%, #D4AF7A 100%)',
              boxShadow: '0 4px 20px rgba(229, 165, 160, 0.4), 0 8px 40px rgba(212, 175, 122, 0.3), inset 0 2px 0 rgba(255, 255, 255, 0.2)',
              border: '2px solid rgba(212, 175, 122, 0.4)'
            }} data-id="element-137">
                {/* Animated golden border glow */}
                <div className="absolute inset-0 rounded-xl md:rounded-2xl" style={{
                background: 'linear-gradient(135deg, #D4AF7A, #F5E6D3, #D4AF7A, #F5E6D3)',
                backgroundSize: '300% 300%',
                animation: 'gradient-shift 3s ease infinite',
                padding: '2px',
                WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
                WebkitMaskComposite: 'xor',
                maskComposite: 'exclude',
                opacity: 0.5
              }} data-id="element-138" />

                {/* Outer glow effect */}
                <div className="absolute inset-0 rounded-xl md:rounded-2xl" style={{
                boxShadow: '0 0 20px rgba(212, 175, 122, 0.5), 0 0 40px rgba(229, 165, 160, 0.3)',
                animation: 'pulse-glow-branded 2s ease-in-out infinite'
              }} data-id="element-139" />

                {/* Glass shine overlay */}
                <div className="absolute inset-0 bg-gradient-to-b from-white/20 via-transparent to-transparent rounded-xl md:rounded-2xl" data-id="element-140" />

                {/* Animated shine sweep */}
                <motion.div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/25 to-transparent rounded-xl md:rounded-2xl" animate={{
                x: ['-100%', '200%']
              }} transition={{
                duration: 3,
                repeat: Infinity,
                repeatDelay: 1,
                ease: 'easeInOut'
              }} data-id="element-141" />

                <span className="relative flex items-center justify-center gap-2 text-xl md:text-2xl font-bold text-white tracking-tight text-center" style={{
                textShadow: '0 2px 8px rgba(61, 48, 40, 0.4), 0 1px 2px rgba(61, 48, 40, 0.3)'
              }} data-id="element-142">
                  Accedé ahora al Master
                  <ArrowIcon className="w-5 h-5 md:w-6 md:h-6 group-hover:translate-x-1 transition-transform duration-300" data-id="element-143" />
                </span>
                <span className="relative text-sm md:text-base font-semibold tracking-wide text-center text-white/95" style={{
                textShadow: '0 1px 4px rgba(61, 48, 40, 0.3)'
              }} data-id="element-144">
                  🔒 Garantía De 7 Días
                </span>
              </motion.button>
            </div>
          </motion.div>

          {/* Hero Image - Desktop Only (side by side) */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="hidden lg:block relative" data-id="element-145">
            <button onClick={scrollToPrice} className="block relative rounded-2xl overflow-hidden shadow-xl border border-[#D4C4B0]/20 hover:shadow-2xl transition-shadow duration-300 cursor-pointer w-full" data-id="element-146">
              <img src="https://cdn.magicpatterns.com/uploads/v2FtTdrXnipb7phZdB754r/fa807582-4f21-4da1-bce9-cfdad40f259c.png" alt="Domina el Hydra Gloss Lips - Master Online Paso a Paso" className="w-full h-auto object-cover" data-id="element-147" />
            </button>
          </motion.div>
        </div>
      </div>

      <style jsx data-id="element-148">{`
        @keyframes pulse-glow-branded {
          0%,
          100% {
            box-shadow:
              0 0 20px rgba(212, 175, 122, 0.4),
              0 0 40px rgba(229, 165, 160, 0.25);
          }
          50% {
            box-shadow:
              0 0 30px rgba(212, 175, 122, 0.6),
              0 0 60px rgba(229, 165, 160, 0.4);
          }
        }

        @keyframes gradient-shift {
          0%,
          100% {
            background-position: 0% 50%;
          }
          50% {
            background-position: 100% 50%;
          }
        }
      `}</style>
    </section>;
}